.videoPlayerContainer {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.videoWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #57585c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: block;
}

.controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  padding: 20px 16px 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.videoWrapper:hover .controls {
  opacity: 1;
}

.progressContainer {
  width: 100%;
  margin: 0;
  padding: 0 12px;
}

.progressBar {
  position: relative;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  cursor: pointer;
  margin-bottom: 8px;
}

.progressFill {
  height: 100%;
  background: #ffffff;
  border-radius: 2px;
  transition: width 0.1s ease;
}

.progressHandle {
  position: absolute;
  top: 50%;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.progressBar:hover .progressHandle,
.progressHandle:hover {
  opacity: 1;
}

.timeDisplay {
  font-size: 11px;
  color: white;
  font-family: "Roboto", sans-serif;
  text-align: right;
  white-space: nowrap;
}

.leftControls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.bottomControls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px 0;
}

.controls.compact .bottomControls {
  justify-content: space-between;
}

.controlButton {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.controlButton:hover {
  background: rgba(255, 255, 255, 0.1);
}

.controlButton:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.2);
}

.controlButton.muted {
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .controls {
    padding: 15px 8px 8px;
  }

  .controlButtons {
    gap: 6px;
  }

  .progressHandle {
    width: 14px;
    height: 14px;
  }
}
